import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import CourseFormatCard from 'src/components/PostGraduationContent/PostgraduateComponents/CourseFormatCard/CourseFormatCard'
import { useGlobalStyles } from 'src/mui/styles/globalStyles'
import { useStyles } from './InformationTab.styles'

const Information = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const globalClasses = useGlobalStyles()

  const courseFormat = [
    {
      title: t('news.postgraduate.info.c1'),
      lines: ['400 h/a', '(25 créditos)']
    },
    {
      title: t('news.postgraduate.info.c2'),
      lines: ['400 h', '(25 créditos)']
    },
    { title: t('news.postgraduate.info.c3'), lines: ['32 h', '(2 créditos)'] },
    { title: t('news.postgraduate.info.c4'), lines: ['96 h', '(6 créditos)'] },
    {
      title: t('news.postgraduate.info.total'),
      lines: ['528 h/a', '(33 créditos)']
    },
    {
      title: t('news.postgraduate.info.options'),
      lines: ['Segundas a sextas,', 'manhã e tarde']
    },
    {
      title: t('news.postgraduate.info.spots'),
      lines: [
        '10 vagas (ampla concorrência)',
        '1 vaga (servidores e docentes da UFC)'
      ]
    }
  ]

  return (
    <>
      <Typography className={globalClasses.titleSectionVariant2}>
        {t('news.postgraduate.info.tab-title')}
      </Typography>
      <Box className={classes.contentContainer}>
        <Box className={classes.cardsGrid}>
          {courseFormat.map((item, index) => (
            <CourseFormatCard
              key={index}
              title={item.title}
              lines={item.lines}
            />
          ))}
        </Box>
      </Box>
      <Box className={classes.contentContainer}>
        <Typography variant="h3" className={globalClasses.titleSectionVariant2}>
          {t('news.postgraduate.intro.info.title')}
        </Typography>
        <Typography className={classes.paragraph}>
          {t('news.postgraduate.info.p1')}
        </Typography>
        <Typography className={classes.paragraph}>
          {t('news.postgraduate.info.p2')}
        </Typography>
        <ul className={classes.dotList}>
          <li>
            Desenvolvimento de softwares para assegurar a privacidade de dados;
          </li>
          <li>
            Desenvolvimento de softwares para a conformidade dos sistemas com a
            legislação vigente (LGPD, etc);
          </li>
          <li>
            Desenvolvimento de softwares para análise automática da segurança de
            bancos de dados;
          </li>
          <li>
            Desenvolvimento de softwares para análise automática da segurança de
            smartphones e dispositivos portáteis;
          </li>
          <li>
            Desenvolvimento de softwares para análise automática da segurança de
            redes de computadores;
          </li>
          <li>Desenvolvimento de softwares para detecção de intrusão;</li>
          <li>
            Desenvolvimento de softwares para aplicação automática de patches de
            segurança;
          </li>
          <li>
            Desenvolvimento de scripts e metodologias para realização de testes
            de intrusão (pentests);
          </li>
          <li>Desenvolvimento de planos de segurança cibernética;</li>
          <li>Desenvolvimento de planos de gestão de riscos;</li>
          <li>Desenvolvimento de planos de resposta a incidentes;</li>
          <li>Desenvolvimento de software seguro;</li>
          <li>
            Refatoração de código para contornar vulnerabilidades ou problemas
            de segurança;
          </li>
          <li>Auditoria de sistemas informatizados e bancos de dados;</li>
          <li>
            Administração de ambientes computacionais, implantando e
            documentando rotinas, bem como controlando os níveis de serviço de
            sistemas operacionais, banco de dados e redes;
          </li>
          <li>Análise de códigos maliciosos;</li>
          <li>
            Desenvolvimento de antivírus utilizando inteligência artificial;
          </li>
          <li>
            Desenvolver guias de melhores práticas voltados para desenvolvimento
            de código seguro, segurança de bancos de dados, privacidade de
            dados, realização de testes de intrusão, monitoramento de
            vulnerabilidades, dentre outros.
          </li>
        </ul>
      </Box>
      <Box className={classes.contentContainer}>
        <Typography variant="h3" className={globalClasses.titleSectionVariant2}>
          {t('news.postgraduate.info.obg')}
        </Typography>
        <Typography className={classes.paragraph}>
          Capacitar os profissionais das áreas de Tecnologia da Informação (TI)
          e afins para que possam atuar na segurança cibernética de instituições
          públicas ou privadas, utilizando metodologias e ferramentas
          reconhecidas com base nas melhores práticas fornecidas pela família
          ABNT ISO/IEC 27000.
        </Typography>
      </Box>
      <Box className={classes.contentContainer}>
        <Typography variant="h3" className={globalClasses.titleSectionVariant2}>
          {t('news.postgraduate.info.obe')}
        </Typography>
        <ul className={classes.dotList}>
          <li>
            Capacitar os alunos para o desenvolvimento e gestão de projetos e
            planos de segurança cibernética, com base em normas internacionais e
            modelos de melhores práticas;
          </li>
          <li>
            Capacitar os estudantes para atuar na proteção de ambientes físicos,
            equipamentos, sistemas computacionais e da informação;
          </li>
          <li>
            Capacitar profissionais para aplicar mecanismos e controles que
            permitam minimizar os impactos relacionados a falhas na segurança
            cibernética;
          </li>
          <li>
            Permitir ao profissional compreender as implicações das legislações
            relacionadas à segurança e privacidade de dados no universo da
            tecnologia da informação e comunicação;
          </li>
          <li>
            Capacitar os alunos no desenvolvimento de aplicações seguras
            (software seguro);
          </li>
          <li>
            Desenvolver, nos profissionais, habilidades para identificar
            problemas, vulnerabilidades e riscos relacionados à segurança
            cibernética, bem como propor soluções apropriadas;
          </li>
          <li>
            Formar profissionais de segurança cibernética com visão de negócios,
            processos e tecnologias;
          </li>
          <li>
            Preparar o profissional de TI para planejar, implementar e gerir
            soluções de segurança cibernética eficientes e inovadoras;
          </li>
          <li>
            Preparar o profissional para avaliar os aspectos estratégicos que
            envolvem segurança cibernética.
          </li>
        </ul>
      </Box>
    </>
  )
}

export default Information
